import { types, flow } from 'mobx-state-tree'

import { DataStore } from './data-store/data-store'

type Action = Generator<Promise<unknown>, void>

export const ProfessionModel = types.model('Profession', {
  id: types.identifierNumber,
  name: types.string,
  image: types.string,
  description: types.string,
  job_description: types.string,
  is_students_allowed: types.number,
  is_disabled_in_apps: types.number,
})

export const professionActions = (self: DataStore) => ({
  getProfessions: flow(function* ({
    hasShiftsFrom,
    hasShiftsTo,
    hasShiftsAtLocationIds,
  }: {
    hasShiftsFrom?: string | null
    hasShiftsTo?: string | null
    hasShiftsAtLocationIds?: number[] | null
  }): Action {
    let queryString = 'common/professions?'
    if (hasShiftsFrom) {
      queryString += `&hasShiftsFrom=${hasShiftsFrom}`
    }
    if (hasShiftsTo) {
      queryString += `&hasShiftsTo=${hasShiftsTo}`
    }
    if (hasShiftsAtLocationIds) {
      hasShiftsAtLocationIds.forEach(locationId => {
        queryString += `&hasShiftsAtLocationIds[]=${locationId}`
      })
    }

    const professions = (yield self.request('get', queryString)) as ProfessionSnapshot[]
    self.professions.clear()
    professions.forEach(profession => {
      self.professions.set(String(profession.id), profession)
    })
  }),
})

export const professionViews = (self: DataStore) => ({
  getProfessionIdByTitle(title: string) {
    return Array.from(self.professions.values()).find(profession => profession.name === title)?.id
  },

  getProfessionName(id: number) {
    return Array.from(self.professions.values()).find(role => role.id === id)?.name
  },

  getProfession(id: number) {
    return Array.from(self.professions.values()).find(role => role.id === id)
  },

  get professionList() {
    return Array.from(self.professions.values()).filter(profession => profession.is_disabled_in_apps !== 1)
  },
})

export type Profession = typeof ProfessionModel.Type
export type ProfessionSnapshot = typeof ProfessionModel.SnapshotType
